const paths: Record<string, string> = {
  menu: '<path d="M4 6h16M4 12h16M4 18h16"/>',
  close: '<path d="M6 6l12 12M18 6 6 18"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
  user: '<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-5 5-7 8-7s6.5 2 8 7"/>',
  tree: '<path d="M12 2c-3 0-5 2-5 5-3 0-5 2-5 5s2 5 5 5h3v5h4v-5h3c3 0 5-2 5-5s-2-5-5-5c0-3-2-5-5-5Z"/>',
  leaf: '<path d="M21 3C13 3 5 7 5 15c0 3 2 6 5 6 8 0 11-10 11-18Z"/><path d="M3 21c5-5 9-9 15-12"/>',
  clipboard: '<rect x="6" y="4" width="12" height="17" rx="2"/><path d="M9 4V2h6v2M9 9h6M9 13h6M9 17h4"/>',
  scissors: '<circle cx="6" cy="7" r="3"/><circle cx="6" cy="17" r="3"/><path d="m8.5 8.5 11 7M8.5 15.5l11-7"/>',
  pin: '<path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/>',
  map: '<path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3Z"/><path d="M9 3v15M15 6v15"/>',
  chart: '<path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/>',
  users: '<circle cx="9" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M3 20c1-4 3.5-6 6-6s5 2 6 6M14 15c2.5 0 5 1.5 6 5"/>',
  file: '<path d="M6 2h8l4 4v16H6Z"/><path d="M14 2v5h5M9 12h6M9 16h6"/>',
  alert: '<path d="M12 3 2 21h20Z"/><path d="M12 9v5M12 18h.01"/>',
  download: '<path d="M12 3v12M7 10l5 5 5-5M4 21h16"/>',
  eye: '<path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12Z"/><circle cx="12" cy="12" r="2.5"/>',
  phone: '<path d="M5 3h4l2 5-3 2c1 3 3 5 6 6l2-3 5 2v4c0 2-2 3-4 3C9 22 2 15 2 7c0-2 1-4 3-4Z"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v6l4 2"/>',
  info: '<circle cx="12" cy="12" r="10"/><path d="M12 11v6M12 7h.01"/>',
  camera: '<path d="M4 7h4l2-3h4l2 3h4v13H4Z"/><circle cx="12" cy="13" r="4"/>',
  shield: '<path d="M12 2 20 5v6c0 5-3 9-8 11-5-2-8-6-8-11V5Z"/><path d="m9 12 2 2 4-5"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  chevron: '<path d="m9 18 6-6-6-6"/>',
  filter: '<path d="M3 5h18l-7 8v6l-4 2v-8Z"/>',
  check: '<path d="m5 12 4 4 10-10"/>',
  layers: '<path d="m12 2 9 5-9 5-9-5Z"/><path d="m3 12 9 5 9-5M3 17l9 5 9-5"/>',
  building: '<path d="M4 21V6l8-4 8 4v15M8 9h2M14 9h2M8 13h2M14 13h2M10 21v-4h4v4"/>',
  heart: '<path d="M20.8 4.6c-2-2-5-2-7 0L12 6.4l-1.8-1.8c-2-2-5-2-7 0s-2 5 0 7L12 20l8.8-8.4c2-2 2-5 0-7Z"/>',
  book: '<path d="M4 5c4-2 6-1 8 1v15c-2-2-4-3-8-1ZM20 5c-4-2-6-1-8 1v15c2-2 4-3 8-1Z"/>',
};

interface IconProps {
  name: string;
  size?: number;
  className?: string;
}

export default function Icon({ name, size = 22, className = '' }: IconProps) {
  const body = paths[name] || paths.info;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
}
